export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const generateImageUrl = (url) => {
  if (!url) return 'https://via.placeholder.com/400x300?text=No+Image';
  const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://localhost:7001';
  if (url.startsWith('http')) return url;
  return `${baseUrl}${url}`;
};

export const validationRules = {
  required: (value) => (!value ? 'This field is required' : null),
  email: (value) => (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? 'Invalid email' : null),
  minLength: (min) => (value) => (!value || value.length < min ? `Minimum ${min} characters` : null),
  maxLength: (max) => (value) => (value && value.length > max ? `Maximum ${max} characters` : null),
};
